/**
 * Clipping Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.8.25
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ClientAnalyticsMediaRow {
    mediumId?: string;
    name?: string;
    type?: 'PRINTED' | 'WEB' | 'TV' | 'RADIO' | 'SOCIAL';
    mentions?: number;
    avgReach?: number;
    avgImpact?: number;
    hasEnoughData?: boolean;
    positivePercent?: number;
    neutralPercent?: number;
    negativePercent?: number;
    previousMentions?: number;
}
